// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.page_note_found {
    position: relative;
    margin-top: 300px;
}

#error-page {
    position: absolute;
    top: 10%;
    left: 15%;
    right: 15%;
    bottom: 10%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #fff;
    box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.1);
}

#error-page .content {
    max-width: 600px;
    text-align: center;
}

#error-page .content h2.header {
    font-size: 18vw;
    line-height: 1em;
    position: relative;
    color:var(--admin-color);
}

#error-page .content h2.header:after {
    position: absolute;
    content: attr(data-text);
    top: 0;
    left: 0;
    right: 0;
    /* background: -webkit-repeating-linear-gradient(-45deg,var(--admin-color), #71b7e6, #69a6ce, #b98acc, #ee8176, #b98acc, #69a6ce, #9b59b6); */
    background-size: 400%;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    text-shadow: 1px 1px 2px rgba(255, 255, 255, 0.25);
    animation: animate 10s ease-in-out infinite;
}

@keyframes animate {
    0% {
        background-position: 0 0;
    }

    25% {
        background-position: 100% 0;
    }

    50% {
        background-position: 100% 100%;
    }

    75% {
        background-position: 0% 100%;
    }

    100% {
        background-position: 0% 0%;
    }
}

#error-page .content h4 {
    font-size: 1.5em;
    margin-bottom: 20px;
    text-transform: uppercase;
    color: #000;
    font-size: 2em;
    max-width: 600px;
    position: relative;
}

#error-page .content h4:after {
    position: absolute;
    content: attr(data-text);
    top: 0;
    left: 0;
    right: 0;
    text-shadow: 1px 1px 2px rgba(255, 255, 255, 0.4);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
}

#error-page .content p {
    font-size: 1.2em;
    color: #0d0d0d;
}

#error-page .content .btns {
    margin: 25px 0;
    display: inline-flex;
}

#error-page .content .btns button {
    display: inline-block;
    margin: 0 10px;
    text-decoration: none;
    border: 2px solid var(--admin-color);
    color: var(--admin-color);
    font-weight: 500;
    padding: 10px 25px;
    border-radius: 25px;
    text-transform: uppercase;
    transition: all 0.3s ease;
}

#error-page .content .btns button:hover {
    background: var(--admin-color);
    color: #fff;
}`, "",{"version":3,"sources":["webpack://./src/Components/Global/PageNotFound.jsx/PageNotFound.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,UAAU;IACV,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,2CAA2C;AAC/C;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,wBAAwB;AAC5B;;AAEA;IACI,kBAAkB;IAClB,wBAAwB;IACxB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,6IAA6I;IAC7I,qBAAqB;IACrB,6BAA6B;IAC7B,oCAAoC;IACpC,kDAAkD;IAClD,2CAA2C;AAC/C;;AAEA;IACI;QACI,wBAAwB;IAC5B;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,4BAA4B;IAChC;;IAEA;QACI,0BAA0B;IAC9B;AACJ;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,yBAAyB;IACzB,WAAW;IACX,cAAc;IACd,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,wBAAwB;IACxB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,iDAAiD;IACjD,6BAA6B;IAC7B,oCAAoC;AACxC;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,oBAAoB;AACxB;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,qBAAqB;IACrB,oCAAoC;IACpC,yBAAyB;IACzB,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,yBAAyB;IACzB,yBAAyB;AAC7B;;AAEA;IACI,8BAA8B;IAC9B,WAAW;AACf","sourcesContent":[".page_note_found {\n    position: relative;\n    margin-top: 300px;\n}\n\n#error-page {\n    position: absolute;\n    top: 10%;\n    left: 15%;\n    right: 15%;\n    bottom: 10%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: #fff;\n    box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.1);\n}\n\n#error-page .content {\n    max-width: 600px;\n    text-align: center;\n}\n\n#error-page .content h2.header {\n    font-size: 18vw;\n    line-height: 1em;\n    position: relative;\n    color:var(--admin-color);\n}\n\n#error-page .content h2.header:after {\n    position: absolute;\n    content: attr(data-text);\n    top: 0;\n    left: 0;\n    right: 0;\n    /* background: -webkit-repeating-linear-gradient(-45deg,var(--admin-color), #71b7e6, #69a6ce, #b98acc, #ee8176, #b98acc, #69a6ce, #9b59b6); */\n    background-size: 400%;\n    -webkit-background-clip: text;\n    -webkit-text-fill-color: transparent;\n    text-shadow: 1px 1px 2px rgba(255, 255, 255, 0.25);\n    animation: animate 10s ease-in-out infinite;\n}\n\n@keyframes animate {\n    0% {\n        background-position: 0 0;\n    }\n\n    25% {\n        background-position: 100% 0;\n    }\n\n    50% {\n        background-position: 100% 100%;\n    }\n\n    75% {\n        background-position: 0% 100%;\n    }\n\n    100% {\n        background-position: 0% 0%;\n    }\n}\n\n#error-page .content h4 {\n    font-size: 1.5em;\n    margin-bottom: 20px;\n    text-transform: uppercase;\n    color: #000;\n    font-size: 2em;\n    max-width: 600px;\n    position: relative;\n}\n\n#error-page .content h4:after {\n    position: absolute;\n    content: attr(data-text);\n    top: 0;\n    left: 0;\n    right: 0;\n    text-shadow: 1px 1px 2px rgba(255, 255, 255, 0.4);\n    -webkit-background-clip: text;\n    -webkit-text-fill-color: transparent;\n}\n\n#error-page .content p {\n    font-size: 1.2em;\n    color: #0d0d0d;\n}\n\n#error-page .content .btns {\n    margin: 25px 0;\n    display: inline-flex;\n}\n\n#error-page .content .btns button {\n    display: inline-block;\n    margin: 0 10px;\n    text-decoration: none;\n    border: 2px solid var(--admin-color);\n    color: var(--admin-color);\n    font-weight: 500;\n    padding: 10px 25px;\n    border-radius: 25px;\n    text-transform: uppercase;\n    transition: all 0.3s ease;\n}\n\n#error-page .content .btns button:hover {\n    background: var(--admin-color);\n    color: #fff;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
